import { Card, Divider } from "antd"
import FormattedTitle from "../../../components/FormattedTitle"
import { FormattedMessage } from "react-intl"
import { FieldArray, FormSection } from "redux-form"
import React from "react"

import { LinksContainer } from "./LinksContainer"
import { MoveUpButton } from "../MoveUpButton"
import { RemoveButton } from "../RemoveButton"
import { FieldArrayFieldsProps } from "redux-form/lib/FieldArray"
import { ConditionalLink, TitledLink } from "../../../types"
import { VisibilityButton } from "../VisibilityButton"
import { LinkFields } from "./LinkFields"

interface Props {
  fieldName: string
}

export const LinksStep = ({ fieldName }: Props) => {
  return (
    <FormSection name={fieldName} className="fade-in">
      <Card title={<FormattedTitle id={"form.step.addLinks.title"} />} bordered={false}>
        <FormattedMessage id="form.step.addLinks.description" />
      </Card>
      <FieldArray name="conditionalList" component={LinksContainer} suffix={<Divider />}>
        {(
          name: string,
          field: ConditionalLink,
          index: number,
          fields: FieldArrayFieldsProps<ConditionalLink>
        ) => (
          <FormSection name={name} component={LinkFields} urlDisabled disabled={!field.enabled}>
            <MoveUpButton disabled={index === 0} onMoveUp={() => fields.swap(index, index - 1)} />
            <VisibilityButton
              visible={field.enabled}
              onVisibilityChange={() =>
                fields.splice(index, 1, { ...field, enabled: !field.enabled })
              }
              target={"link"}
            />
          </FormSection>
        )}
      </FieldArray>
      <FieldArray
        name="staticList"
        component={LinksContainer}
        createNew={() => ({ url: "http://", title: "" })}
      >
        {(
          name: string,
          _field: TitledLink,
          index: number,
          fields: FieldArrayFieldsProps<TitledLink>
        ) => (
          <FormSection name={name} component={LinkFields}>
            <MoveUpButton disabled={index === 0} onMoveUp={() => fields.swap(index, index - 1)} />
            <RemoveButton onRemove={() => fields.remove(index)} target={"link"} />
          </FormSection>
        )}
      </FieldArray>
    </FormSection>
  )
}
